export const SET_OFF_MARKET_PROPERTY = 'SET_OFF_MARKET_PROPERTY';
export const UPDATE_OFF_MARKET_PROPERTY = 'UPDATE_OFF_MARKET_PROPERTY';
export const CLEAR_OFF_MARKET_PROPERTY = 'CLEAR_OFF_MARKET_PROPERTY';
export const SET_OFF_MARKET_PROPERTY_VERIFIED_OWNER = 'SET_OFF_MARKET_PROPERTY_VERIFIED_OWNER';
export const SET_OFF_MARKET_PROPERTY_OWNER_CONTACT_METHOD_SCORE = 'SET_OFF_MARKET_PROPERTY_OWNER_CONTACT_METHOD_SCORE';
export const DELETE_OFF_MARKET_PROPERTY_OWNERSHIP = 'DELETE_OFF_MARKET_PROPERTY_OWNERSHIP';
export const ADD_OFF_MARKET_PROPERTY_OWNERSHIP = 'ADD_OFF_MARKET_PROPERTY_OWNERSHIP';
export const UPDATE_OFF_MARKET_PROPERTY_CONTACT = 'UPDATE_OFF_MARKET_PROPERTY_CONTACT';

export function setOffMarketPropertyId(propertyId: string) {
  return (dispatch) => {
    dispatch({
      type: SET_OFF_MARKET_PROPERTY,
      payload: { propertyId, owners: null }
    });
  };
}

// TODO_GL: I had to add this becasue on the call list map view
// the store is behaving differently, so I'm using the useDispatch (preferred)
// on that page, which cannot use the dispatch as part of this file to
// successfully set the store state
// we should consider migrating all of our store work to use useDispatch
export function setOffMarketPropertyIdPayload(propertyId: string) {
  return {
    type: SET_OFF_MARKET_PROPERTY,
    payload: { propertyId, owners: null }
  };
}

export function setOffMarketProperty(property) {
  return (dispatch) => {
    dispatch({
      type: SET_OFF_MARKET_PROPERTY,
      payload: property
    });
  };
}

export function updateOffMarketProperty(data) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_OFF_MARKET_PROPERTY,
      payload: data
    });
  };
}

export function clearOffMarketProperty() {
  return { type: CLEAR_OFF_MARKET_PROPERTY };
}
